import { PipeTransform } from '@angular/core';
var PhoneFormatPipe = /** @class */ (function () {
    function PhoneFormatPipe() {
    }
    PhoneFormatPipe.prototype.transform = function (value) {
        value = String(value);
        if (!value) {
            return value;
        }
        if (value.length === 10) {
            return value.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
        }
        if (value.length === 11) {
            return value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        }
        return value;
    };
    return PhoneFormatPipe;
}());
export { PhoneFormatPipe };
